export  const getAllowedExtensions = (fileTypes) => {
  const allowedExtensions = fileTypes.map(fileType => fileType.extensions).flat().join(',');
  return allowedExtensions;
};